export default __webpack_public_path__ + "images/4158959602e34e5297ad1331b3372a5d-renaissance_small.webp";